import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ImpressaoService} from "../../services/impressao.service";
import {PedidosService} from "../../services/pedidos.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {LayoutPedido} from "../../services/impressao/LayoutPedido";
import {ProcessadorReciboTexto} from "../../services/impressao/ProcessadorReciboTexto";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'info-pedido',
  templateUrl: './info-pedido.component.html',
  styleUrls: ['./info-pedido.component.scss']
})
export class InfoPedidoComponent implements OnInit {
  @Input()
  public pedido: any;
  @Input()
  public contato: any;
  public empresa: any = {}
  @Input()
  public permiteAlterarStatus: boolean;
  @Input()
  public permiteEditarPedido = false;
  @Input() modal: any = false;
  @Input() modoGrupoLojas = false;
  imprimindo: boolean;
  configImpressao: any;
  impressoras = [];

  constructor(private router: Router, private impressao: ImpressaoService,
              private constantsService: ConstantsService,
              private pedidosService: PedidosService) { }

  ngOnInit() {
    this.constantsService.empresa$.subscribe((empresa) => {
      if(empresa && !this.modoGrupoLojas){
        this.empresa = empresa;
        this.configImpressao = this.empresa.configImpressao;
        this.carregueImpressorasConfiguradas();
      }
    })

  }

  carregueImpressorasConfiguradas() {
    const impressorasConfiguradas = this.configImpressao?.impressoras || [];
    this.impressoras = impressorasConfiguradas.filter((impressora: any) => impressora && !impressora.removida);
  }

  exibeSeletorImpressoras(): boolean {
    return !!this.configImpressao?.multiplasImpressoras && this.impressoras.length > 1;
  }

  possuiImpressoraUnicaConfigurada(): boolean {
    return !!this.configImpressao?.multiplasImpressoras && this.impressoras.length === 1;
  }

  obtenhaImpressoraPadrao(): any {
    return this.impressoras[0] || null;
  }

  mudarStatus(pedido: any) {
    this.router.navigateByUrl('/admin/pedidos/mudar-status/' + pedido.codigo + '?urlRetorno=' + location.pathname, {
      state: {pedido:  pedido, contato: this.contato, empresa: this.empresa}
    } );
  }

  verPedido(pedido: any){
    this.router.navigateByUrl(  String(`/admin/pedidos/detalhes/${pedido.guid}?urlRetorno=${location.pathname}`),
      { state: pedido });
  }


  imprimaPedidoResumido(){
    this.imprimaPedido('PedidoResumido')
  }

  imprimaPedidoDoLayout(){
    this.imprimaPedido(this.configImpressao ? this.configImpressao.layoutPedido : null  )
  }

  imprimaPedido(layoutPedido: string = 'PedidoCompleto') {
    if(!this.configImpressao  || !this.configImpressao.imprimirTXT)
      window.open('/imprimir/pedido/' + this.pedido.guid + '?l=' + layoutPedido);
    else
      this.imprimaNativamente(null, layoutPedido)
  }

  imprimaNativamente(impressora: any = null, layoutPedido: string  = null ) {
    const impressoraSelecionadaBase = impressora || this.obtenhaImpressoraPadrao();

    if(!impressoraSelecionadaBase) {
      this.impressao.onErrosImpressao.emit('Nenhuma impressora configurada');
      return;
    }

    const impressoraSelecionada = {...impressoraSelecionadaBase};
    const layout = this.obtenhaLayoutPadrao(impressoraSelecionada, layoutPedido);

    if(layout)
      impressoraSelecionada.layout = layout;

    this.imprimaAutomaticamente(impressoraSelecionada);
  }

  imprimaAutomaticamente(impressora: any) {
    this.imprimindo = true;

    //todo: tiranda codigo que verifica tah carregado pelos itens ( pode vim brindes carregados, extra pedido) fazer analise depois
    this.pedidosService.obtenhaPorCodigo(this.pedido.guid).then( (pedidoCompleto) => {
      this.imprimaPedidoNaImpressora(pedidoCompleto, impressora);
    }).catch((err) => {
       console.error(err)
      this.imprimindo = false;
    });

  }

  private async imprimaPedidoNaImpressora(pedidoCompleto, impressora: any) {
    try {
      await this.impressao.imprimaPedidoNaImpressora(pedidoCompleto, impressora)
      this.imprimindo = false;
    } catch (erro) {
      this.imprimindo = false;
      console.error(erro)
      alert("Houve um erro ao imprimir: " + erro)
    }
  }

  private obtenhaLayoutPadrao(impressora: any = null, layoutPedido: string = null): string {
    let layout = layoutPedido || impressora?.layout || this.configImpressao?.layoutPedido;

    if(layout === 'Completo')
      return 'PedidoCompleto';

    if(layout === 'Resumido')
      return 'PedidoResumido';

    if(layout === 'Ambos')
      return 'PedidoCompleto';

    return layout;
  }

  editar(pedido: any, event = null) {
    if(this.permiteEditarPedido)
      this.router.navigateByUrl('/pedidos/' + pedido.codigo);

    if(event){
      event.stopPropagation();
      event.preventDefault();
    }

    return false;
  }


  enviarMensagemLinkPagamento(pedido) {
    pedido.gerandoMsgLink = true;
    window['root'].envieMensagemLinkPagamento(pedido.guid);
    setTimeout( () => {
      pedido.gerandoMsgLink = false;
    }, 30000)
  }
}
